var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai_design"},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"title":"您可对已选定的AI生成图片进行全方位编辑：不仅支持文本内容修改与元素布局调整，还提供智能抠图、主体自动提取及AI内容消除等高级图像处理功能，助力高效实现精准化、专业级的视觉优化。","width":"60%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_vm._v(" 加载中 ... .... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }